

import { FeiraProvider } from "../Contexts/FeiraContext";
import { useParams } from "react-router-dom";

import MapaLoader from "../pages/Mapa/MapaLoader";

const PaginaMapaIndependente2 = () => {
  const { idFeira } = useParams();

  return (
    <FeiraProvider idFeira={idFeira}>
       <MapaLoader />
    </FeiraProvider>
  );
};

export default PaginaMapaIndependente2;